<app-page-header title="Home" active_item="Conversão Cripto" titleLink="/reports"></app-page-header>
<div class="loading-crypto" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>
<div class="card rounded-10 shadow p-5 mb-5">
  <div class="d-flex gap-4">
    <div class="alert flex-fill text-center mb-0" style="background:#0052cc25" role="alert">
      <strong>
      {{ 'common.balanceInConversion' | translate }}:
      {{emConversao | formatCurrency}}
      </strong>
    </div>
    <div class="alert flex-fill text-center mb-0" style="background:#0052cc25" role="alert">
      <strong>
        {{ 'common.processingCrypto' | translate }}:
        {{emProcessamento | number:'1.4-4'}}
      </strong>
    </div>
  </div>
</div>
  <h5>{{ 'common.cryptoCurrency' | translate }}</h5>


<div class="card rounded-10 shadow" *ngIf="!isInsert && !isCopyPaste">
  <div class="card-header">
    <div class="card-title mb-0">{{ 'common.cryptoDeposit' | translate }}</div>
    <button type="button" class="our-button btn btn-pill btn-primary float-end" (click)="openWithdraw()">
      <i class="fe fe-arrow-up-right"></i>{{ 'common.deposit' | translate }}
    </button>
  </div>
  <div class="card-body">
    <div class="scrollable-layout">
      <div class="table-responsive our-table">
        <table class="table table-striped text-nowrap mb-0">
          <thead class="border-top">
            <tr>
              <th scope="col" class="text-capitalize">{{ 'common.date' | translate}}</th>
              <th scope="col" class="text-capitalize">{{ 'common.currency' | translate }}</th>
              <th scope="col" class="text-capitalize">{{ 'common.wallet' | translate }}</th>
              <th scope="col" class="text-capitalize">{{ 'common.brlValue' | translate }}</th>
              <th scope="col" class="text-capitalize">{{ 'common.quote' | translate }}</th>
              <th scope="col" class="text-capitalize">{{ 'common.cryptoValue' | translate }}</th>
              <th scope="col" class="text-capitalize">{{ 'common.depositStatus' | translate }}</th>
              <th scope="col" class="text-capitalize">{{ 'common.cryptoStatus' | translate }}</th>
              <th scope="col" class="text-capitalize">{{ 'common.txId' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="border-bottom" *ngFor="let crypto of cryptos">
              <td><span>{{crypto.data | date : 'dd/MM/yyyy HH:mm:ss':'GMT'}}</span></td>
              <td><span>{{crypto.symbol}}</span></td>
              <td><span>{{crypto.wallet}}</span></td>
              <td><span>{{crypto.brlValue | formatCurrency }}</span></td>
              <td><span> R$ {{crypto.valueCotacao | number:'1.4-4':'pt-BR' }}</span></td>
              <td><span> {{crypto.value | number:'1.4-4':'pt-BR' }}</span></td>
              <td class="align-middle">
                <span class="status-badge" [ngClass]="formatStatusClass(crypto.statusProvedor)">
                  {{ crypto.statusProvedor | label:'status' }}
                </span>
              </td>
              <td class="align-middle">
                <span class="status-badge" [ngClass]="formatStatusClass(crypto.status)">
                  {{ crypto.status | label:'status' }}
                </span>
              </td>
              <td class="txid" (click)="crypto.txId && copyTxid(crypto.txId)">
                <div class="txid-container" *ngIf="crypto.txId">
                  <i class="fe fe-copy" style="margin-right: 8px;"></i>
                  <span class="truncate" [attr.title]="crypto.txId">{{crypto.txId}}</span>
                </div>
              </td>
            </tr>
            <tr *ngIf="cryptos.length == 0">
              <td colspan="12">{{ 'common.noData' | translate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between p-2">
        <ngb-pagination
          [collectionSize]="total" [maxSize]="5" [rotate]="true" [(page)]="page" [pageSize]="pageSize" (pageChange)="pageChange()">
        </ngb-pagination>
      </div>
    </div>
  </div>
</div>

<div class="card rounded-10 shadow" *ngIf="isInsert">
  <div class="card-header">
    <div class="card-title mb-0">{{ 'common.insertWallet' | translate }}</div>
  </div>
  <div class="card-body">
    <form [formGroup]="cryptoDeposit">
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-sm-6">
          <div class="form-group">
            <label for="slSymbols" class="form-label">{{ 'common.currency' | translate}} <span class="text-danger">*</span></label>
            <ng-select id="slSymbols" [searchable]="false" [clearable]="false" [items]="symbols" bindValue="id" bindLabel="description" 
                       [formControl]="cryptoDeposit.controls.symbol" (change)="loadWallets()" />
            <div class="invalid-feedback">{{ 'common.currencyRequiredMessage' | translate }}!</div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-sm-6">
          <div class="form-group">
            <label for="slCarteira" class="form-label">{{ 'common.wallet' | translate }} <span class="text-danger">*</span></label>
            <ng-select id="slCarteira" [searchable]="false" [clearable]="false" [items]="wallets" bindValue="id" 
                       [formControl]="cryptoDeposit.controls.wallet">
              <ng-template ng-option-tmp let-item="item">
                {{item.description}} {{item.hash}}
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                {{item.description}} {{item.hash}}
              </ng-template>
            </ng-select>
            <div class="invalid-feedback">{{ 'common.walletRequiredMessage' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-sm-6">
          <div class="form-group">
            <label for="slDepositType" class="form-label">
              {{ 'common.depositType' | translate }} <span class="text-danger">*</span>
            </label>
            <ng-select id="slPixType" [items]="depositTypes" bindValue="value" bindLabel="label" 
                       [searchable]="false" [clearable]="false" [formControl]="cryptoDeposit.controls.depositType">
            </ng-select>
            <div class="invalid-feedback">
              {{ 'common.pixTypeRequiredMessage' | translate }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-4 col-lg-4 col-sm-4">
            <div class="form-group">
              <label for="txtValue" class="form-label">{{ 'common.fiatValue' | translate }} <span class="text-danger">*</span></label>
              <input placeholder="{{0 | formatCurrency }}"  currencyMask [options]="{ prefix: ('' | currencySymbol) + ' ' }" 
                     [formControl]="cryptoDeposit.controls.value" class="form-control" type="text" id="txtValue"
                     [ngClass]="{'is-invalid state-invalid': cryptoDeposit.controls.value.invalid && isSubmitted}" 
                     (focusout)="valorChanged()">
              <div class="invalid-feedback">{{ 'common.valueRequired' | translate }}</div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-sm-4">
            <div class="form-group">
              <label for="txtValue" class="form-label">{{ 'common.quote' | translate }}</label>
              <input placeholder="{{ 0 | formatCurrency }}"  currencyMask 
                     [options]="{ prefix: ('' | currencySymbol) + ' ', decimal: '.', thousands: '.', precision: 4 }" 
                     [formControl]="cryptoDeposit.controls.quote" class="form-control" type="text" id="txtValue" [readonly]="true">
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-sm-4">
            <div class="form-group">
              <label for="txtTotalValue" class="form-label">{{ 'common.cryptoCurrencyAmount' | translate }}</label>
              <input [formControl]="cryptoDeposit.controls.cryptoValue"  currencyMask 
                     [options]="{prefix: '', decimal: ',', thousands: '.', precision: 4}" 
                     class="form-control" type="text" id="txtTotalValue" [readonly]="true" />
            </div>
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-pill btn-primary float-start" (click)="return()">
        <i class="fe fe-arrow-left"></i>{{ 'common.back' | translate }}
      </button>
      <button type="button" class="btn btn-pill btn-primary float-end" (click)="nextStep()">
        {{ 'common.continue' | translate }}<i class="fe fe-arrow-right"></i>
      </button>
    </form>
  </div>
</div>

<div class="card rounded-10 shadow" *ngIf="isPixKey">
  <div class="card-header">
    <div class="card-title mb-0">{{ 'common.bankDetails' | translate }}</div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-xl-4 col-lg-4 col-sm-4">
        <div class="form-group">
          <label for="txtChavePix" class="form-label">{{ 'common.pixKey' | translate }} </label>
          <div class="input-icon-container"> 
            <input [formControl]="cryptoDeposit.controls.pixKey" class="form-control" type="text" id="txtChavePix" 
                   [(ngModel)]="chavePixDeposito" [readonly]="true">
            <i (click)="copy()" class="fe fe-copy input-icon-copy"></i>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-sm-4">
        <div class="form-group">
          <label for="txtNomeTitular" class="form-label">{{ 'common.holderName' | translate }} </label>
          <input [formControl]="cryptoDeposit.controls.holderName" [(ngModel)]="nomeTitular" 
                 class="form-control" type="text" id="txtNomeTitular" [readonly]="true"> 
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-sm-4">
        <div class="form-group">
          <label for="txtBanco" class="form-label">{{ 'common.bank' | translate }}</label>
          <input [formControl]="cryptoDeposit.controls.bank" [(ngModel)]="banco"  
                 class="form-control" type="text" id="txtBanco" [readonly]="true" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-sm-6">
        <div class="form-group">
          <label class="form-label">
            {{'common.paymentReceipt' | translate }} <span class="text-danger">*</span>
          </label>
          <input type="file" class="form-control file-upload-input" (change)="onFileSelected($event)" accept="application/pdf,image/*" />
        </div>
      </div>
      <div class="input-container">
        <button type="button" class="btn btn-pill btn-primary float-start mt-3" (click)="confirmPixKeyDeposit()">
          {{ 'common.depositButton' | translate }}<i class="fe fe-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="card rounded-10 shadow" *ngIf="isCopyPaste">
  <div class="card-header">
    <div class="card-title mb-0">
      {{ "common.paymentInformation" | translate }}
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-xl-3 col-lg-6 col-sm-6 text-center">
        <h5 class="text-center">{{ "common.qrCode" | translate }}</h5>
        <img [src]="qrCodeBase64" alt="Qr Code" class="img-fluid" style="max-width: 200px;"/>
      </div>
      <div class="col-xl-9 col-lg-6 col-sm-6">
        <h5 class="text-center mb-3">{{ "common.copyPaste" | translate }}</h5>
        <div class="input-group">
          <button class="btn btn-primary" (click)="copyPixCode()">
            <i class="fe fe-copy"></i>
          </button>
          <textarea class="form-control" rows="4" readonly>{{ pixCopiaECola }}</textarea>
        </div>
        <button class="btn btn-primary w-100 mt-3" (click)="return()">
          {{ "common.finish" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #requestTOTPCode let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ 'common.informAuthToken' | translate }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click'); isLoaded = true;"></button>
  </div>
  <div class="modal-body">
    <div class="form-group mt-2">
      <p *ngIf="errorMessage.length > 0" class="text-danger">
        {{errorMessage}}
      </p>
    </div>
    <div class="form-group mb-3">
      <input type="text" class="form-control" id="authToken" placeholder="Token" [(ngModel)]="validationCode" (keyup.enter)="validateTotp()">
      <button (click)="pasteTotpCode()" class="btn btn-primary btn-block btn-colar h-30 w-30 mx-auto mt-2 mb-1">
        {{'login.totp.pasteButton' | translate}}
      </button>
    </div>
  </div>
  <div class="modal-footer text-center">
    <button type="submit" class="btn btn-lg btn-primary btn-pill mx-auto d-block" (click)="validateTotp()">
      {{ 'common.validateButton' | translate }}
    </button>
  </div>
</ng-template>